const PHRASES = [
  "EXECUTION OVER EVERYTHING",
  "POSITION • EVENT • ENTRY",
  "DATA OVER EMOTION",
  "PROCESS OVER PREDICTION",
  "KNOW YOUR POSITION",
  "EXECUTE THE ENTRY",
];

export function Marquee() {
  return (
    <div
      data-testid="motto-marquee"
      className="overflow-hidden border-y border-line bg-[#070809] py-6 sm:py-8"
    >
      <div className="animate-marquee flex w-max">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
            {PHRASES.map((p, i) => (
              <div key={i} className="flex items-center">
                <span
                  className={`whitespace-nowrap font-display text-3xl font-extrabold uppercase tracking-tight sm:text-5xl ${
                    i % 2 === 0 ? "text-white/90" : "text-stroke"
                  }`}
                >
                  {p}
                </span>
                <span className="mx-8 h-2 w-2 rotate-45 bg-neon/70 sm:mx-12" />
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
